// removed by extract-text-webpack-plugin
module.exports = {"paper":"_3rCMbRNFovJ9nWXDBVgnG7","resultsTable":"il2wJPka2XqmAHzNDlfu6","problemNames":"_2ZZaZlztsXbVzBaWTi1hoi","participantData":"ZcuWE7MyUagPZESJYIpAf","participantResult":"_1eduo9rsoCQcP6GHLjmLd8","row":"y7x8LzakV2gxag1dsD9PF","col":"_1f3SMHEsoX0290Xvbrv7bg","coeffTable":"nbYk5pJ-BUbsBPDj4uu0h","openInNew":"_1WTx1Qsx2Lsv-SPVkmBL7d"};


//////////////////
// WEBPACK FOOTER
// ./src/Pages/PublicReportPage/PublicReportPage.css
// module id = 816
// module chunks = 3